import React from 'react';
import Link from 'atomic/utilization/link';
import Skeleton from 'react-loading-skeleton';
import BoxProductsCarousel from 'components/box-product-carousel';
import { useFetch } from 'hooks/use-fetch';
import { approximateNumber } from 'helpers/approximate-number';
import { InView } from 'react-intersection-observer';

const ProductWidgetSimilarProduct: React.FC<{
    isMobile: boolean;
    categoryUrl: string;
    productUrl: string;
}> = ({ isMobile, categoryUrl, productUrl }) => {
    const { data, error, get } = useFetch(`${productUrl}/similar-product`, { method: 'GET' });

    const onView = (inView: boolean): void => {
        if (inView) {
            get();
        }
    };

    let similarProducts = data;

    if (similarProducts !== null && error) {
        similarProducts = null;
    }

    if (similarProducts && similarProducts.items.length === 0) {
        similarProducts = null;
    }

    return (
        <InView triggerOnce={true} as="div" onChange={onView}>
            <BoxProductsCarousel
                headerTitle="Produkty polecane dla Ciebie"
                products={similarProducts}
                isMobile={isMobile}
            >
                {!isMobile && (
                    <>
                        W tej kategorii mamy ponad
                        <div>
                            <strong>
                                &nbsp;
                                {(similarProducts === null) ? <Skeleton width={40}/> : approximateNumber(similarProducts.count)}
                                &nbsp;produktów&nbsp;
                            </strong>
                        </div>
                    </>
                )}

                <Link href={categoryUrl} type="button" outline={true}
                    uppercase={true} color="blue" weight="600"
                >
                    Zobacz więcej
                </Link>
            </BoxProductsCarousel>
        </InView>
    );
};

export default ProductWidgetSimilarProduct;
